import {UPDATE_LOGIN_DATA, IS_AUTHENTICATED, UPDATE_USER_PROFILE, UPDATE_AUTH, CLIENT_TYPE_CHANGE} from './actions';

const initialState = {
  usersArray:[],
    deleteUserResp:{},
    errorCMsg:{},
    saveUserResp:{},
    loginData:{},
    isAuthenticatedBool:false,
    userProfile:{},
    auth:null,
  clientType:'vehicleOwner'
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case UPDATE_AUTH:
          console.log("I am called to update AUth, Farshid " );
          return Object.assign({}, state, {
              auth: action.auth
          });
      case UPDATE_USER_PROFILE:
          console.log("I am called to update the profile, Farshid " );
          return Object.assign({}, state, {
              userProfile: action.userProfile
          });
     /* case LOAD_LOGIN_DATA:
          return Object.assign({}, state, {
              loginData: action.loginData
          });
      case SAVE_LOGIN_DATA:
          return Object.assign({}, state, {
              loginData: action.saveLoginResponse,
              errorCMsg: action.errorMsg
          });
          */
      case UPDATE_LOGIN_DATA:
          return Object.assign({}, state, {
              loginData: action.updateLoginResponse,
              errorCMsg: action.errorMsg
          });
        
        
    case CLIENT_TYPE_CHANGE:
      return Object.assign({}, state, {
        clientType: action.clientType
      });
      
      
      case IS_AUTHENTICATED: {
          let expiresAt = action.expiresAt;//initialState.loginData.expiresAt;
          let returnValue = new Date().getTime() < expiresAt;
          return Object.assign({}, state, {
              isAuthenticatedBool: returnValue,
          });
      }

    default:
      return state;
  }
}
